exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs.flex-column .nav-item.show .nav-link[data-v-69bbb77e],.nav-tabs.flex-column .nav-link.active[data-v-69bbb77e]{border-left:3px solid #17a2b8}.nav-item active[data-v-69bbb77e]{background-color:#17a2b8}.list-group-item[data-v-69bbb77e]{padding:2px 0}.profile-username[data-v-69bbb77e]{font-size:20px;margin-top:5px}.nav-link[data-v-69bbb77e]{font-weight:600}textarea[data-v-69bbb77e]{width:100%;height:100%;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69bbb77e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/complaint/Complaints.vue
// module id = 177
// module chunks = 0